import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import DecisionJointCertificateInstallContent from '@/components/tax-refund/individual/DecisionRefund/JointCertificate/install/DecisionJointCertificateInstallContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const DecisionJointCertificateInstallPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증정보입력);

  return (
    <AuthGuard>
      <Layout leftIcon={{ icon: 'back' }} rightTextButton={rightInquiryButton}>
        <DecisionJointCertificateInstallContent />
      </Layout>
    </AuthGuard>
  );
};

export default DecisionJointCertificateInstallPage;
